import React from 'react'

export default function Reviews() {
  return (
    <>
      <section className="reviews">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h2 className="heading">Stories Shared by Fellow Travelers</h2>
            </div>
            <div className="col-md-6">
                <div className="subReview">
                    <h3>Exceptional service, unforgettable 
                        experiences!</h3>
                    <p>Exceptional service, unforgettable experiences! Reliable, professional, and always exceeding expectations.</p>    
                </div>
            </div>
            <div className="col-md-6">
                <div className="subReview">
                    <h3>Exceptional service, unforgettable 
                        experiences!</h3>
                    <p>Exceptional service, unforgettable experiences! Reliable, professional, and always exceeding expectations.</p>    
                </div>
            </div>
            <div className="col-md-6">
                <div className="subReview">
                    <h3>Exceptional service, unforgettable 
                        experiences!</h3>
                    <p>Exceptional service, unforgettable experiences! Reliable, professional, and always exceeding expectations.</p>    
                </div>
            </div>
            <div className="col-md-6">
                <div className="subReview">
                    <h3>Exceptional service, unforgettable 
                        experiences!</h3>
                    <p>Exceptional service, unforgettable experiences! Reliable, professional, and always exceeding expectations.</p>    
                </div>
            </div>
        </div>
    </div>
</section>
    </>
  )
}
